/**
 * Created by Ning Jiang on 2022-03-10.
 */

import {SerialReelView} from "./SerialReelView";

export class ReelPositionController {

    public static DEFAULT_SYMBOL_HEIGHT:number = 156; // 104, 78
    public static DEFAULT_SYMBOL_WIDTH:number = 134;

    public static REEL_AREAS:PIXI.Rectangle[] = [
        new PIXI.Rectangle(92, 72, ReelPositionController.DEFAULT_SYMBOL_WIDTH * 2, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 4),
        new PIXI.Rectangle(226, 72, ReelPositionController.DEFAULT_SYMBOL_WIDTH * 2, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 4),
        new PIXI.Rectangle(360, 72, ReelPositionController.DEFAULT_SYMBOL_WIDTH * 2, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 4),
        new PIXI.Rectangle(494, 72, ReelPositionController.DEFAULT_SYMBOL_WIDTH * 2, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 4),
        new PIXI.Rectangle(628, 72, ReelPositionController.DEFAULT_SYMBOL_WIDTH * 2, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 4)
    ]

    public readonly reelId:number;
    private readonly _topReelViews:SerialReelView[];
    private readonly _bottomReelViews:SerialReelView[];
    private readonly _middleReelView:SerialReelView;

    constructor(reelId:number, topReelViews:SerialReelView[], bottomReelViews:SerialReelView[], middleReelView:SerialReelView) {
        this.reelId = reelId;
        this._topReelViews = topReelViews;
        this._bottomReelViews = bottomReelViews;
        this._middleReelView = middleReelView;
        this.arrange();
    }

    public arrange():void {
        let middleTop = ReelPositionController.REEL_AREAS[this.reelId].y;
        let middleBottom = middleTop + ReelPositionController.REEL_AREAS[this.reelId].height;

        this._topReelViews.forEach(topReelView => {
            topReelView.resetHeight();
            topReelView.resetPosition(middleTop);
            middleTop += topReelView.currentHeight;
        });
        this._bottomReelViews.forEach(bottomReelView => {
            bottomReelView.resetHeight();
            middleBottom -= bottomReelView.currentHeight;
            bottomReelView.resetPosition(middleBottom);
        });
        this._middleReelView.resetHeight(middleBottom - middleTop);
        this._middleReelView.resetPosition(middleTop);
    }
}